import React, {Component} from 'react'

import { connect } from 'react-redux'
import SettingsHome from './components/Settings/SettingsHome'

import {
  setTitle
} from 'common/redux/root'

import { fetchSettings } from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsHomeContainer extends Component {

  componentWillMount() {
    const { dispatch } = this.props

    dispatch(setTitle("Lead Settings"))
    dispatch(fetchSettings())
  }

  render() {
    const { settings } = this.props

    if (Object.keys(settings).length > 1) {
      return <SettingsHome {...this.props} />
    }
    return null
  }

}

export default connect((state) => ({ settings: state.settings, auth: state.auth }), mapDispatchToProps)(SettingsHomeContainer)
